import petrovich from 'petrovich';
import { popup } from 'app/common/actions/popup';

import api from '../api';

//
//  FETCH BALANCE
//

export const CAFETERIA_BALANCE_REQUEST = 'CAFETERIA_BALANCE_REQUEST';
export const CAFETERIA_BALANCE_SUCCESS = 'CAFETERIA_BALANCE_SUCCESS';
export const CAFETERIA_BALANCE_FAIL = 'CAFETERIA_BALANCE_FAIL';

const failedCafeteriaBalance = err => ({
  type: CAFETERIA_BALANCE_FAIL,
  payload: { err },
});

const receiveCafeteriaBalance = data => ({
  type: CAFETERIA_BALANCE_SUCCESS,
  payload: data,
});

const requestCafeteriaBalance = () => ({
  type: CAFETERIA_BALANCE_REQUEST,
});


/**
 * Загрузить баланс средств учеников
 */
export function fetchBalance() {
  return async (dispatch) => {
    try {
      dispatch(requestCafeteriaBalance());
      const response = await api('cabinet/cafeteria/balance', 'get');
      dispatch(receiveCafeteriaBalance({ ...response.data }));
    } catch (error) {
      dispatch(failedCafeteriaBalance('Не удалось получить данные о балансе'));
    }
  };
}


// TRANSFER


export const CAFETERIA_TRANSFER_REQUEST = 'CAFETERIA_TRANSFER_REQUEST';
export const CAFETERIA_TRANSFER_SUCCESS = 'CAFETERIA_TRANSFER_SUCCESS';
export const CAFETERIA_TRANSFER_FAIL = 'CAFETERIA_TRANSFER_FAIL';

const failedCafeteriaTransfer = err => ({
  type: CAFETERIA_TRANSFER_FAIL,
  payload: { err },
});

const receiveCafeteriaTransfer = data => ({
  type: CAFETERIA_TRANSFER_SUCCESS,
  payload: data,
});

const requestCafeteriaTransfer = () => ({
  type: CAFETERIA_TRANSFER_REQUEST,
});

export function transfer({ from, to, amount }) {
  return async (dispatch, getState) => {
    try {
      dispatch(requestCafeteriaTransfer());
      const state = getState();
      let response;
      if (from === 'user') {
        response = await api('cabinet/cafeteria/payments/transfer/parent-to-student', 'post',
          { data: { to: parseInt(to, 10), amount: parseFloat(amount) } });
        // Показать popup сообщение о переводе

        const toStudent = state.students.data[to];
        const toName = petrovich({ ...toStudent.name, gender: toStudent.sex }, 'dative').first;

        dispatch(popup(`${amount} Р успешно переведены \n От Вас к ${toName}`));
      } else {
        response = await api('cabinet/cafeteria/payments/transfer/student-to-student', 'post',
          { data: { from: parseInt(from, 10), to: parseInt(to, 10), amount: parseFloat(amount) } });

        // Показать popup сообщение о переводе
        const fromStudent = state.students.data[from];
        const fromName = petrovich({ ...fromStudent.name, gender: fromStudent.sex }, 'genitive').first;

        const toStudent = state.students.data[to];
        const toName = petrovich({ ...toStudent.name, gender: toStudent.sex }, 'dative').first;

        dispatch(popup(`${amount} Р успешно переведены \n От ${fromName} к ${toName}`));
      }
      dispatch(receiveCafeteriaTransfer({ ...response.data }));
    } catch (err) {
      dispatch(failedCafeteriaTransfer('Не удалось совершить перевод'));
    }
  };
}

export const CAFETERIA_TRANSFER_CLEAR = 'CAFETERIA_TRANSFER_CLEAR';
export function clear() {
  return { type: CAFETERIA_TRANSFER_CLEAR };
}

export const CAFETERIA_BALANCE_CLEAR = 'CAFETERIA_BALANCE_CLEAR';
export function balanceClear() {
  return { type: CAFETERIA_BALANCE_CLEAR };
}
